export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const REPLACE_EVENTS = 'REPLACE_EVENTS';
export const UPDATE_EVENTS = 'UPDATE_EVENTS';
